var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2001_1632)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.6666 12C24.6666 5.37262 19.294 0 12.6666 0C6.03925 0 0.666626 5.37262 0.666626 12C0.666626 17.9895 5.05488 22.954 10.7916 23.8542V15.4688H7.74475V12H10.7916V9.35625C10.7916 6.34875 12.5832 4.6875 15.3243 4.6875C16.6371 4.6875 18.0104 4.92188 18.0104 4.92188V7.875H16.4973C15.0065 7.875 14.5416 8.80003 14.5416 9.74906V12H17.8698L17.3377 15.4688H14.5416V23.8542C20.2784 22.954 24.6666 17.9896 24.6666 12Z",
    fill: "#1877F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3377 15.4688L17.8698 12H14.5416V9.74906C14.5416 8.79994 15.0065 7.875 16.4973 7.875H18.0104V4.92188C18.0104 4.92188 16.6371 4.6875 15.3242 4.6875C12.5832 4.6875 10.7916 6.34875 10.7916 9.35625V12H7.74475V15.4688H10.7916V23.8542C11.4119 23.9514 12.0388 24.0001 12.6666 24C13.2945 24.0001 13.9214 23.9514 14.5416 23.8542V15.4688H17.3377Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2001_1632"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.666626)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.4bf3ec7ac81a2b8c06750e8f2e7a0e20.svg";
export { ForwardRef as ReactComponent };